import format from "date-fns/format";
import { utcToZonedTime } from "date-fns-tz";
import React from "react";
import { Ticket } from "../../../models/Ticket";
import "./changeDate.scss";
import "../../../../style/alerts.scss";
import { useTranslation } from "react-i18next";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  ticket: Ticket;
  alert: string;
}

const FutureTicketChange: React.FC<IProps> = ({ ticket, alert }: IProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="future-ticket-change">
        <div className="future-ticket-change-dialog">
          <span>{t("aby_zmienic_termin_najpierw_musisz_zrezygnowac_z_obecnego")}</span>
          {ticket.exercises && (
            <div className="alert alert-yellow">
              <b>{ticket.exercises[0].name}</b>
              <span>
                {format(ticket.exercises[0].startTime, "yyyy-MM-dd")} / {t("godz")}
                {format(utcToZonedTime(ticket.exercises[0].startTime, "Europe/Warsaw"), "HH:mm")}
              </span>
            </div>
          )}
        </div>
        {alert.length > 2 && <EAAlert type="error" message={alert} />}
      </div>
    </>
  );
};

export default FutureTicketChange;
